import styled from 'styled-components';
import { COLOURS, FONT_COLOURS, FONT_WEIGHT, getBodyFont } from '@belong/themes';
import { Icon, withLink } from '@belong/ui-components';

export const Wrapper = withLink(styled.button`
  align-items: start;
  background: transparent;
  border-radius: 0.8rem;
  border: 2px solid transparent;
  color: white;
  cursor: pointer;
  display: flex;
  justify-content: start;
  text-decoration: none;
  width: 100%;
  ${getBodyFont('medium')}

  &[aria-current] {
    color: ${FONT_COLOURS.ACTIVE};
    font-weight: ${FONT_WEIGHT.BOLD};
  }

  &:focus {
    border: 0.2rem solid ${COLOURS.BELONG_BLUE_ALT};
    color: ${FONT_COLOURS.ACTIVE};
    outline: none;
  }

  &&:focus * {
    color: ${FONT_COLOURS.ACTIVE};
  }

  &:hover {
    color: ${FONT_COLOURS.ACTIVE};
    text-decoration: underline;
  }
`);

export const StyledIcon = styled(Icon)`
  margin-right: 0.8rem;
`;
